export const PolicyStatusCodes = [
    { value: 'Active/In-force', label: 'Active/In-force' },
    { value: 'Fully Paid', label: 'Fully Paid' },
    { value: 'Lapsed', label: 'Lapsed' },
    { value: 'Cessation/Ceased', label: 'Cessation/Ceased' },
    { value: 'Death', label: 'Death' },
];
